import { render, staticRenderFns } from "./courseAuthDetail.vue?vue&type=template&id=b11b114e&scoped=true&"
import script from "./courseAuthDetail.vue?vue&type=script&lang=js&"
export * from "./courseAuthDetail.vue?vue&type=script&lang=js&"
import style0 from "./courseAuthDetail.vue?vue&type=style&index=0&id=b11b114e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11b114e",
  null
  
)

export default component.exports